import { render, staticRenderFns } from "./publicizeMaterialInWarehouse.vue?vue&type=template&id=256c9ce5&scoped=true&"
import script from "./publicizeMaterialInWarehouse.vue?vue&type=script&lang=js&"
export * from "./publicizeMaterialInWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./publicizeMaterialInWarehouse.vue?vue&type=style&index=0&id=256c9ce5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c9ce5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256c9ce5')) {
      api.createRecord('256c9ce5', component.options)
    } else {
      api.reload('256c9ce5', component.options)
    }
    module.hot.accept("./publicizeMaterialInWarehouse.vue?vue&type=template&id=256c9ce5&scoped=true&", function () {
      api.rerender('256c9ce5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/publicizeMaterialInWarehouse.vue"
export default component.exports